import he from "he";

/**
  HTML entity encoder/decoder, handles ambiguous ampersands and other edge cases.
  https://www.npmjs.com/package/he
*/
const heDecode = (string: string) => {
  if (string) {
    const result = he.decode(string);
    return result;
  }
};

/**
 * Remove special characters from Json string.
 */
export const sanatiseStr = (string: string) => {
  if (string) {
    const str = he.decode(string);

    return str;
  }
};
